import {
  BookOpen,
  BookUser,
  Boxes,
  Building2,
  CalendarRange,
  Calculator,
  ClipboardList,
  FileCog,
  FileOutput,
  FolderTree,
  Hammer,
  Hash,
  History,
  Home,
  Landmark,
  Library,
  ListTree,
  Package,
  Percent,
  ReceiptText,
  ScanBarcode,
  ServerCog,
  Settings,
  ShoppingCart,
  SlidersHorizontal,
  Tags,
  Truck,
  Undo2,
  Upload,
  UserCog,
  Users,
  Wallet,
  Warehouse,
  Banknote,
} from 'lucide-react';
import type { NombreDeIcono } from './secciones';

/**
 * Del nombre de un ícono al dibujo.
 *
 * ## Por qué un mapa y no importar directo en cada lado
 *
 * Porque `secciones.ts` lo lee una prueba que corre sin navegador y compara dos listas de texto: si
 * ese archivo importara componentes de React, la prueba tendría que montar medio árbol para
 * verificar que ninguna pantalla quedó fuera del menú. El nombre viaja como texto y se convierte en
 * dibujo acá, que es donde ya hay React.
 *
 * ## Por qué se enumeran uno por uno
 *
 * Importar la biblioteca entera con `import * as` mete cerca de mil quinientos íconos en el
 * paquete. Enumerarlos deja treinta.
 */
const DIBUJOS = {
  Banknote,
  BookOpen,
  BookUser,
  Boxes,
  Building2,
  Calculator,
  CalendarRange,
  ClipboardList,
  FileCog,
  FileOutput,
  FolderTree,
  Hammer,
  Hash,
  History,
  Home,
  Landmark,
  Library,
  ListTree,
  Package,
  Percent,
  ReceiptText,
  ScanBarcode,
  ServerCog,
  Settings,
  ShoppingCart,
  SlidersHorizontal,
  Tags,
  Truck,
  Undo2,
  Upload,
  UserCog,
  Users,
  Wallet,
  Warehouse,
} satisfies Record<NombreDeIcono, unknown>;

export function Icono({
  nombre,
  className,
}: {
  readonly nombre: NombreDeIcono;
  readonly className?: string;
}): React.ReactElement {
  const Dibujo = DIBUJOS[nombre];
  // `aria-hidden` siempre: el nombre de la pantalla está escrito al lado, y un lector de pantalla
  // que además anuncie «icono de paquete» dice dos veces lo mismo.
  return <Dibujo className={className} aria-hidden strokeWidth={1.75} />;
}
